/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdDto } from '../../models/ad-dto';
import { CreateAdDto } from '../../models/create-ad-dto';

export interface AdControllerCreate$Params {
  
    /**
     * ad 알림 생성 정보
     */
    body: CreateAdDto
}

export function adControllerCreate(http: HttpClient, rootUrl: string, params: AdControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdDto>> {
  const rb = new RequestBuilder(rootUrl, adControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdDto>;
    })
  );
}

adControllerCreate.PATH = '/api/ad';
